import React,{useState,useEffect} from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
// import Navbar2 from '../components/Navbar2';
import Footer from '../components/Footer';
import PlacesToVisit from '../components/PlacesToVisit';
import Sroll from '../components/Scroll';
import AmenitiesMenu from '../components/AmenitiesMenu';


function PlacesToVisitPage() {
   
    const [isOpen,setIsOpen]= useState(false);
    const toggle= ()=>{
        setIsOpen(!isOpen);
    }
   


    return (
        <div>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            {/* <Navbar2 toggle={toggle}  />  */}
            <Navbar toggle={toggle}  /> 
            <PlacesToVisit />
            <AmenitiesMenu />
            <Sroll />
            <Footer />
        </div>
    )
}

export default PlacesToVisitPage
